export default __webpack_public_path__ + "4dc353759a6e9954a86215e5ac8c6b3e.svg";